import { render } from "./add-club.template.html?vue&type=template&id=4725eb75&scoped=true"
import script from "./AddClub.vue?vue&type=script&lang=ts"
export * from "./AddClub.vue?vue&type=script&lang=ts"

import "./AddClub.vue?vue&type=style&index=0&id=4725eb75&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4725eb75"

export default script